import { openComponentInPopup } from "./common";
import { PopupOptions, PopupWidth } from "./popup";

export default class PriceMatrixLink {
    private linkElement: HTMLAnchorElement;
    popupWidth: PopupWidth;

    constructor(linkElement: HTMLAnchorElement) {
        this.linkElement = linkElement;
        this.popupWidth = linkElement.dataset.popupWidth as PopupWidth ?? PopupWidth.Large;
    }

    public init(): void {
        this.linkElement.addEventListener('click', (event) => {
            event.preventDefault();
            this.openPriceMatrix();
        });
    }

    private openPriceMatrix(): void {
        openComponentInPopup(
            'PriceMatrix',
            null,
            <PopupOptions>{ id: 'price-matrix-popup', width: this.popupWidth });
    }
}
